import { MaterialTypes } from 'constants/data'
import { generateTumbnail, generateStaticPreview } from 'utils/generatePreview'

const getPreview = (
  basePath: string,
  previewName?: string,
  videoLink?: string,
  materialType?: MaterialTypes,
  customWidth?: string
) => {
  const imgData = {
    src: '',
    isCheckNeed: false,
  }
  if (previewName)
    imgData.src = generateStaticPreview(basePath, previewName, materialType, customWidth)
  else if (videoLink) {
    imgData.src = generateTumbnail(videoLink, customWidth)
    imgData.isCheckNeed = true
  }
  return imgData
}

export { getPreview }
